// /client/src/routes/Routes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import Login from '../components/Login';
import Dashboard from '../components/Dashboard';
import Programs from '../components/Programs';
import CreateProgram from '../components/CreateProgram';
import ProgramView from '../components/ProgramView';
import Contacts from '../components/Contacts';
import CreateContact from '../components/CreateContact';
import Pods from '../components/Pods';
import Products from '../components/Products';
import CreateProduct from '../components/CreateProduct';
import EditContact from '../components/EditContact';
import EditProgram from '../components/EditProgram';
import EditProduct from '../components/EditProduct';
import EditPod from '../components/EditPod';
import VerifyEmail from '../components/VerifyEmail';
import SetPassword from '../components/SetPassword';
import Help from '../components/Help';
import Profile from '../components/Profile';
import PublicOptIn from '../components/PublicOptIn';
import TestMMS from '../components/TestMMS';
import Activity from '../components/Activity';
import ResetPassword from '../components/ResetPassword';
import MessageLog from '../components/MessageLog';
import ConversationManager from '../components/ConversationManager';
import CreateDeploy from '../components/CreateDeploy';
import Deployments from '../components/Deployments';
import DeploymentView from '../components/DeploymentView';
import PodDeploymentView from '../components/PodDeploymentView';
import AnalyticsView from '../components/Analytics';
import EditDeployment from '../components/EditDeployment';
import PodRelayManager from '../components/PodRelayManager';
import TwilioMessageQueue from '../components/TwilioMessageQueue';
import ActivateSupport from '../components/ActivateSupport';
import DesignNextMoveGoal from '../components/DesignNextMoveGoal';
import FindClarity from '../components/FindClarity';
import IdentifyResistance from '../components/IdentifyResistance';
import KeepGoing from '../components/KeepGoing';
import PrepareExperience from '../components/PrepareExperience';
import ExternalInternalContext from '../components/ExternalInternalContext';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={
        <Login />
      } />

      <Route path="/activate-support" element={
        <ActivateSupport />
      } />

      <Route path="/design-goal" element={
        <DesignNextMoveGoal />
      } />

      <Route path="/find-clarity" element={
        <FindClarity />
      } />

      <Route path="/identify-resistance" element={
        <IdentifyResistance />
      } />

      <Route path="/keep-going" element={
        <KeepGoing />
      } />

      <Route path="/prepare-experience" element={
        <PrepareExperience />
      } />

      <Route path="/external-internal-context" element={
        <ExternalInternalContext />
      } />

      <Route path="/reset-password" element={
        <ResetPassword />
      } />

      <Route path="/optin" element={
        <PublicOptIn />
      } />

      <Route path="/verify-email" element={
        <VerifyEmail />
      } />

      <Route path="/set-password" element={
        <SetPassword />
      } />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />

      <Route path="/test-mms" element={
        <ProtectedRoute>
          <TestMMS />
        </ProtectedRoute>
      } />

      <Route path="/admin/conversations" element={
        <ProtectedRoute>
          <ConversationManager />
        </ProtectedRoute>
      } />
      
      <Route path="/programs" element={
        <ProtectedRoute>
          <Programs />
        </ProtectedRoute>
      } />
      
      {/* Future Protected Routes - Uncomment as components are created */}
      <Route path="/programs/create" element={
        <ProtectedRoute>
          <CreateProgram />
        </ProtectedRoute>
      } />

      <Route path="/programs/:id" element={
        <ProtectedRoute>
          <ProgramView />
        </ProtectedRoute>
      } />

      <Route path="/programs/edit/:id" element={
        <ProtectedRoute>
          <EditProgram />
        </ProtectedRoute>
      } />
      
      <Route path="/products" element={
        <ProtectedRoute>
          <Products />
        </ProtectedRoute>
      } />

      <Route path="/products/create" element={
        <ProtectedRoute>
          <CreateProduct />
        </ProtectedRoute>
      } />

      <Route path="/products/edit/:id" element={
        <ProtectedRoute>
          <EditProduct />
        </ProtectedRoute>
      } />
      
      <Route path="/contacts" element={
        <ProtectedRoute>
          <Contacts />
        </ProtectedRoute>
      } />
      
      <Route path="/contacts/create" element={
        <ProtectedRoute>
          <CreateContact />
        </ProtectedRoute>
      } />

      <Route path="/contacts/:id" element={
        <ProtectedRoute>
          <EditContact />
        </ProtectedRoute>
      } />
      
      <Route path="/pods" element={
        <ProtectedRoute>
          <Pods />
        </ProtectedRoute>
      } />
      
      <Route path="/pods/:id" element={
        <ProtectedRoute>
          <EditPod />
        </ProtectedRoute>
      } />

      <Route path="/pods/relay-manager" element={
        <ProtectedRoute>
          <PodRelayManager />
        </ProtectedRoute>
      } />

      <Route path="/deployments" element={
        <ProtectedRoute>
          <Deployments />
        </ProtectedRoute>
      } />

      <Route path="/deployments/create" element={
        <ProtectedRoute>
          <CreateDeploy />
        </ProtectedRoute>
      } />

      <Route path="/deployments/:id/edit" element={
        <ProtectedRoute>
          <EditDeployment />
        </ProtectedRoute>
      } />

      <Route path="/deployments/:id" element={
        <ProtectedRoute>
          <DeploymentView />
        </ProtectedRoute>
      } />

      <Route path="/deployments/:id/pods/:podId" element={
        <ProtectedRoute>
          <PodDeploymentView />
        </ProtectedRoute>
      } />

      <Route path="/activity" element={
        <ProtectedRoute>
          <Activity />
        </ProtectedRoute>
      } />

      <Route path="/analytics" element={
        <ProtectedRoute>
          <AnalyticsView />
        </ProtectedRoute>
      } />

      <Route path="/messages" element={
        <ProtectedRoute>
          <MessageLog />
        </ProtectedRoute>
      } />

      <Route path="/twilio-queue" element={
        <ProtectedRoute>
          <TwilioMessageQueue />
        </ProtectedRoute>
      } />

      <Route path="/profile" element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      } />

      <Route path="/help" element={
        <ProtectedRoute>
          <Help />
        </ProtectedRoute>
      } />
      
      {/* Default redirect to dashboard for authenticated users */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* Catch-all route for 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;